import * as React from "react";
import {connect} from "react-redux";
import {RouteComponentProps} from "react-router";
import {Action, Dispatch} from "redux";
import {Client} from "../../domain/model/client";
import {Company} from "../../domain/model/company";
import {createClientMypageActionCreator} from "../action/client_mypage_action";
import ClientMypageComponent from "../component/client/mypage/client_mypage";
import {createClientMypageDispatcher, IClientMypageDispatcher,} from "../dispatcher/client_mypage_dispatcher";
import {
    UpdateClientByClientRequest,
    UpdateCompanyByClientRequest,
    UpdateEmailByClientRequest,
    UpdatePasswordByClientRequest,
} from "../request/mypage_request";
import {AppState} from "../store/app_state";
import {AuthState} from "../store/auth_state";
import {ClientMypageState} from "../store/client_mypage_state";

interface IProps extends RouteComponentProps<{ action: string }> {
    state: ClientMypageState;
    authReducer: AuthState;
    dispatcher: IClientMypageDispatcher;
}

interface IState {
    isInit: boolean;
}

export class ClientMypage extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            isInit: true,
        };
    }

    public componentDidMount() {
        this.props.dispatcher.getMeClient();
    }

    public componentDidUpdate(prevProps: IProps, prevState: IState) {
        // init処理の終了
        const isInitFinished: boolean =
            this.state.isInit &&
            !this.props.state.isLoading &&
            prevProps.state.isLoading;
        if (isInitFinished) {
            return this.setState({isInit: false});
        }
    }

    public render(): JSX.Element {
        const {location, match, state} = this.props;
        const {isInit} = this.state;

        const client: Client | null = state.client;
        const company: Company | null = state.company;

        const isLoading: boolean = state.isLoading;

        return (
            <ClientMypageComponent
                isInit={isInit}
                isLoading={isLoading}
                location={location}
                match={match}
                client={client}
                company={company}
                handleUpdateCompanySubmit={this.handleUpdateCompanySubmit}
                handleUpdateClientSubmit={this.handleUpdateClientSubmit}
                handleUpdatePasswordSubmit={this.handleUpdatePasswordSubmit}
                handleUpdateEmailSubmit={this.handleUpdateEmailSubmit}
            />
        );
    }

    // Companyデータ編集用
    private handleUpdateCompanySubmit = (values: any): void => {
        if (this.props.authReducer.user === null) {
            return;
        }

        const req: UpdateCompanyByClientRequest =
            new UpdateCompanyByClientRequest();
        req.name = values.company.name;
        req.logoURL = values.company.gsLogoURL;
        req.webURL = values.company.webURL;
        req.establishedAt = values.company.establishedAt;
        req.postalCode = values.company.postalCode;
        req.place = values.company.place;
        req.business = values.company.business;
        req.representativeName = values.company.representativeName;
        req.capitalStock = values.company.capitalStock;
        req.employeeScale = values.company.employeeScale;
        req.introduction = values.company.introduction;
        req.accordingCompanyName = values.company.accordingCompanyName;
        req.accordingCompanyPostalCode = values.company.accordingCompanyPostalCode;
        req.accordingCompanyAddress = values.company.accordingCompanyAddress;
        req.invoiceDepartmentName = values.company.invoiceDepartmentName;
        req.uploadFileLogoURL = values.logoURLFileObject;

        this.props.dispatcher.updateCompany(req);
    };

    // Clientデータ編集用
    private handleUpdateClientSubmit = (values: any): void => {
        if (this.props.authReducer.user === undefined) {
            return;
        }

        const req: UpdateClientByClientRequest = new UpdateClientByClientRequest();
        req.name = values.client.name;
        req.nameKana = values.client.nameKana;
        req.iconURL = values.client.gsIconURL;
        req.phoneNumber = values.client.phoneNumber;
        req.department = values.client.department;
        req.position = values.client.position;
        req.uploadFileIconURL = values.iconURLFileObject;
        this.props.dispatcher.updateClient(req);
    };

    // Client Password変更
    private handleUpdatePasswordSubmit = (values: any): void => {
        const req: UpdatePasswordByClientRequest =
            new UpdatePasswordByClientRequest();
        req.currentPassword = values.currentPassword;
        req.newPassword = values.password;
        this.props.dispatcher.updatePassword(req);
    };

    // Email変更
    private handleUpdateEmailSubmit = (value: any): void => {
        const req: UpdateEmailByClientRequest = new UpdateEmailByClientRequest();
        req.currentPassword = value.currentPassword;
        req.email = value.email;
        this.props.dispatcher.updateEmail(req);
    };
}

const mapStateToProps = (state: AppState) => {
    return {
        state: state.clientMypageReducer,
        authReducer: state.authReducer,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
    return {
        dispatcher: createClientMypageDispatcher(
            dispatch,
            createClientMypageActionCreator()
        ),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientMypage);



// WEBPACK FOOTER //
// ./src/presentation/container/client_mypage_container.tsx